import ApiClient from './ApiClient';

class WhatsappCostEstimateAPI extends ApiClient {
  constructor() {
    super('whatsapp_cost_estimate', { accountScoped: true });
  }
}

export default new WhatsappCostEstimateAPI();
